





































































































































































































































































































































































































































































import {Vue, Component, Watch, Prop} from 'vue-property-decorator';
// @ts-ignore
import Editor from 'vue2-ace-editor';
import {CodeState} from '@/store/participant';
import {
    checkBreak,
    checkComplete,
    compileAndTest,
    CompileAndTestResult,
    endBreak,
    endQuestion, ChallengeResultSummary,
    ChallengeSummary,
    getQuestion, getSampleQuestion,
    Question,
    QuestionSummary,
    startBreak, submitFeedback, UnitTestResult,
} from '@/services/participant-service';
import {participantVuexNamespace} from '@/store/participant/const';
import {updateAuthHeader} from '@/services/solid-api-service';
import QuestionTimer from '@/components/QuestionTimer.vue';
import {showNotification} from '@/services/notification-service';

@Component({
    components: {
        QuestionTimer,
        Editor,
    },
})
export default class CodeEditor extends Vue {

    @participantVuexNamespace.Getter
    protected challengeSummary!: ChallengeSummary;

    @participantVuexNamespace.Getter
    protected codeState!: CodeState;

    @participantVuexNamespace.Action
    protected saveCodeState!: (codeState: CodeState) => void;

    protected loading: boolean = true;
    protected overlayAlternate: boolean = false;

    protected question: Question = null!;
    protected localCodeState: CodeState = {
        questionNumber: 1,
        code: '',
        templateCode: '',
        problemDescription: '',
        submitted: false,
        sample: false,
        finished: false,
        endTime: null,
    };
    protected consoleOutput: string = '';
    protected unitTestResults: UnitTestResult[] = [];
    protected running: boolean = false;
    protected originalCodeDialog: boolean = false;

    protected confirmNext: boolean = false;

    protected onBreak: boolean = false;
    protected breakEndTime: Date | null = null;

    protected resultSummary: ChallengeResultSummary | null = null;

    protected isSubmittingFeedback: boolean = false;
    protected validFeedback: boolean = false;
    protected feedback: string = '';
    protected feedbackRules: any[] = [
        (v: string) => v.length > 0 || 'Please enter your feedback here.',
        (v: any) => v.length <= 512 || 'Feedback must not be more than 512 characters',
    ];

    @Prop({
        default: (): boolean => false,
    })
    protected sample!: boolean;
    protected tourComplete: boolean = false;

    protected created() {
        if (this.codeState.code !== '') {
            this.localCodeState.code = this.codeState.code;
        }
        this.localCodeState.finished = this.codeState.finished;
        this.localCodeState.templateCode = this.codeState.templateCode;
        this.localCodeState.problemDescription = this.codeState.problemDescription;
        this.localCodeState.endTime = new Date(this.codeState.endTime as unknown as string);
        this.localCodeState.sample = this.codeState.sample;
        this.localCodeState.submitted = this.codeState.submitted;
        this.localCodeState.questionNumber = this.codeState.questionNumber;
        updateAuthHeader(this.challengeSummary.token);
        this.checkBreakAndFetchQuestion();
        this.onOverlayAlternate();
    }

    protected editorInit(editor: any) {
        require('brace/ext/language_tools'); // language extension prerequsite...
        require('brace/mode/java');
        require('brace/theme/chrome');
    }

    protected async checkBreakAndFetchQuestion() {
        try {
            this.loading = true;
            if (!this.localCodeState.sample) {
                this.resultSummary = await checkComplete();
                this.localCodeState.finished = this.resultSummary.complete;
                if (!this.localCodeState.finished) {
                    const breakTime = await checkBreak();
                    if (breakTime.onBreak) {
                        this.onBreak = true;
                        this.localCodeState.endTime = new Date();
                        this.breakEndTime = new Date(Date.now() + breakTime.timer);
                    } else {
                        this.question = await getQuestion();
                        this.unitTestResults = [];
                        this.consoleOutput = '';
                        if (this.question.complete) {
                            this.localCodeState.endTime = new Date();
                            this.localCodeState.finished = true;
                        } else {
                            if (this.localCodeState.code === '' || this.localCodeState.questionNumber !== this.question.number) {
                                this.localCodeState.code = this.question.templateCode + '';
                            }
                            this.localCodeState.templateCode = this.question.templateCode + '';
                            this.localCodeState.problemDescription = this.question.problemDescription + '';
                            this.localCodeState.questionNumber = this.question.number;
                            this.localCodeState.endTime = new Date(Date.now() + this.question.timer);
                            this.setupNotificationTimer();
                        }
                        this.onBreak = false;
                    }
                }
            } else {
                this.question = await getSampleQuestion();
                this.localCodeState.code = this.question.templateCode + '';
                this.localCodeState.templateCode = this.question.templateCode + '';
                this.localCodeState.problemDescription = this.question.problemDescription + '';
                this.localCodeState.questionNumber = this.question.number;
                this.localCodeState.endTime = new Date(Date.now() + this.question.timer);
                this.onBreak = false;
            }
        } catch (error) {
            this.$dialog.error({
                text: error.message,
            });
        }

        this.loading = false;

        this.saveCodeState(this.localCodeState);

        if (this.sample && !this.tourComplete) {
            Vue.nextTick(() => {
                /* eslint-disable */
                if ((this as any).$tours.sampleTest) {
                    (this as any).$tours.sampleTest.start();
                }
                /* eslint-enable */
            });
        }
    }

    protected async onBreakComplete() {
        this.saveCodeState(this.localCodeState);
        if (this.onBreak) {
            try {
                this.loading = true;
                await endBreak();
                await this.checkBreakAndFetchQuestion();
            } catch (error) {
                this.$dialog.error({
                    text: error.message,
                });
            }
            this.loading = false;
        }
    }

    protected async submitAnswer() {
        if (!this.sample) {
            this.confirmNext = true;
        } else {
            this.onTimerComplete();
        }
    }

    protected async onTimerComplete() {
        this.confirmNext = false;
        if (this.question !== null) {
            this.saveCodeState(this.localCodeState);
            if (this.localCodeState.sample) {
                this.$router.push(`/${this.$route.params.key}/start`);
            } else if (!this.localCodeState.finished) {
                try {
                    this.loading = true;
                    await this.run();
                    await endQuestion();
                    this.resultSummary = await checkComplete();
                    if (this.resultSummary.complete) {
                        this.localCodeState.finished = true;
                    } else {
                        await startBreak();
                        await this.checkBreakAndFetchQuestion();
                    }
                } catch (error) {
                    this.$dialog.error({
                        text: error.message,
                    });
                }
                this.loading = false;
            }
        }
    }

    protected async run() {
        try {
            this.running = true;
            this.unitTestResults = [];
            this.consoleOutput = '';
            const result: CompileAndTestResult = await compileAndTest(this.codeState.code);
            this.consoleOutput = result.consoleOutput;
            this.unitTestResults = result.results;
        } catch (error) {
            this.$dialog.error({
                text: error.message,
            });
        }
        this.running = false;
    }

    protected copyToIde(code: string) {
        this.$copyText(code).then(() => {
            this.$dialog.message.success('Copied to clipboard', {
                position: 'top-center',
                timeout: 750,
            });
        });
    }

    protected submitFeedbackClicked(code: string) {
        this.isSubmittingFeedback = true;
    }

    protected async submitFeedback() {
        try {
            this.loading = true;
            await submitFeedback(this.feedback);
            this.isSubmittingFeedback = false;
            this.$dialog.notify.success('Thank you for your feedback!');
            if (this.resultSummary !== null) {
                this.resultSummary.feedbackSubmitted = true;
                this.resultSummary.feedback = this.feedback;
            }
        } catch (error) {
            this.$dialog.error({
                text: error.message,
            });
        }
        this.loading = false;
    }

    @Watch('localCodeState', {deep: true})
    protected onLocalCodeChanged() {
        this.saveCodeState(this.localCodeState);
    }

    protected sampleTestSteps: any[] = [
        {
            target: '#problem-container',
            content: 'See the problem description here.',
        },
        {
            target: '.code-editor',
            content: 'Edit the code here or copy-paste it to/from your IDE (recommended for longer problems).',
        },
        {
            target: '.run-btn',
            content: 'Run your solution. You can run this multiple times while you are testing.',
        },
        {
            target: '.console-output-card',
            content: 'This card shows your program\'s console output.',
        },
        {
            target: '.test-output-card',
            content: 'This card shows the results of unit tests that are executed against your code.',
        },
        {
            target: '.timer-output',
            content: 'This timer indicates how much time you have remaining to complete the current question.',
        },
        {
            target: '.complete-button',
            content: 'Once finished, submit your solution. The "Submit" button accepts your solutions as your final answer.',
        },
    ];

    protected tourCallbacks: any = {
        onStop: () => {
            this.tourComplete = true;
        },
    };

    protected get testsPassed() {
        let count = 0;
        for (const unitTestResult of this.unitTestResults) {
            if (unitTestResult.passed) {
                count++;
            }
        }
        return count;
    }

    protected get testsFailed() {
        let count = 0;
        for (const unitTestResult of this.unitTestResults) {
            if (!unitTestResult.passed) {
                count++;
            }
        }
        return count;
    }

    protected get isFinalQuestion() {
        return this.localCodeState.questionNumber === this.challengeSummary.questionSummaries.length;
    }

    protected onOverlayAlternate() {
        this.overlayAlternate = !this.overlayAlternate;
        setTimeout(this.onOverlayAlternate.bind(this), 1000);
    }

    protected get breakModal() {
        return this.onBreak && !this.loading;
    }

    protected get isFinished() {
        return this.localCodeState.finished && this.resultSummary !== null && this.resultSummary.complete;
    }

    protected intervalId: number = 0;
    protected setupNotificationTimer() {
        window.clearInterval(this.intervalId);
        this.intervalId = window.setInterval(this.onTick.bind(this), 1000);
    }

    protected onTick() {
        if (this.localCodeState !== null) {
            const now = new Date();
            const timeLeft = Math.abs(this.localCodeState!.endTime!.getTime() % now.getTime());
            if (timeLeft < (120000) && timeLeft > (119000)) {
                showNotification('2 minutes remaining');
                window.clearInterval(this.intervalId);
            }
        }
    }

}
